import { render, staticRenderFns } from "./PsPatientChartTrend.vue?vue&type=template&id=01b9c3be&scoped=true&"
import script from "./PsPatientChartTrend.vue?vue&type=script&lang=js&"
export * from "./PsPatientChartTrend.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientChartTrend.vue?vue&type=style&index=0&id=01b9c3be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9c3be",
  null
  
)

export default component.exports